import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  ReactComponent as CatIcon,
} from '../../../../assets/petDemos/cat.svg';
import {
  ReactComponent as DogIcon,
} from '../../../../assets/petDemos/dog.svg';
import {
  ReactComponent as DeleteIcon,
} from '../../../../assets/petDemos/delete.svg';
import { PET_DEMOS_SPECIES } from '../../../../constants';

import styles from './css/PetPill.module.css';

const SPECIE_ICON_COMPONENT = {
  [PET_DEMOS_SPECIES.cat]: CatIcon,
  [PET_DEMOS_SPECIES.dog]: DogIcon,
};

const PetPill = ({
  disabled = false,
  onRemove = () => { },
  pet = {},
}) => {
  const { t } = useTranslation('petDemos');
  const { Name = '', Specie = PET_DEMOS_SPECIES.dog } = pet;
  const IconComponent = SPECIE_ICON_COMPONENT[Specie]
    || SPECIE_ICON_COMPONENT[PET_DEMOS_SPECIES.dog];

  const handleRemove = (event) => {
    event.stopPropagation();
    onRemove(pet);
  };

  return (
    <span className={styles.petPill} data-disabled={disabled}>
      <IconComponent className={styles.pillIcon} />

      <span className={styles.pillName}>{Name}</span>

      {disabled ? null
        : (
          <button
            aria-label={t('removePet', { name: Name })}
            className={styles.removePillButton}
            onClick={handleRemove}
            type="button"
          >
            <DeleteIcon className={styles.removeIcon} />
          </button>
        )}
    </span>
  );
};

export { PetPill };
